import { render, staticRenderFns } from "./QYJ.vue?vue&type=template&id=ba6c8c0c&scoped=true&lang=html&"
import script from "./QYJ.vue?vue&type=script&lang=js&"
export * from "./QYJ.vue?vue&type=script&lang=js&"
import style0 from "./QYJ.vue?vue&type=style&index=0&id=ba6c8c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6c8c0c",
  null
  
)

export default component.exports